import React from 'react';
import { COLORS } from '../utils/constants';

const KEYFRAMES = `
  @keyframes car-alert-toast-in {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

const TYPE_STYLES = {
  success: {
    background: 'rgba(22, 163, 74, 0.15)',
    border: '1px solid rgba(22, 163, 74, 0.4)',
    color: '#86efac',
    icon: '✅',
  },
  error: {
    background: 'rgba(220, 38, 38, 0.15)',
    border: '1px solid rgba(220, 38, 38, 0.4)',
    color: '#fca5a5',
    icon: '❌',
  },
  warning: {
    background: 'rgba(234, 179, 8, 0.15)',
    border: '1px solid rgba(234, 179, 8, 0.4)',
    color: '#fde047',
    icon: '⚠️',
  },
  info: {
    background: 'rgba(0, 217, 255, 0.10)',
    border: `1px solid ${COLORS.cyan}66`,
    color: COLORS.cyan || '#00d9ff',
    icon: 'ℹ️',
  },
};

const Toast = ({ id, message, type = 'info', onRemove }) => {
  const ts = TYPE_STYLES[type] || TYPE_STYLES.info;

  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '12px 16px',
        borderRadius: 12,
        background: ts.background,
        border: ts.border,
        color: ts.color,
        fontSize: 14,
        fontWeight: '500',
        minWidth: 260,
        maxWidth: 380,
        boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
        animation: 'car-alert-toast-in 0.25s ease-out',
        backdropFilter: 'blur(8px)',
      }}
    >
      <span aria-hidden="true">{ts.icon}</span>
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={() => onRemove(id)}
        aria-label="Fechar notificação"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'inherit',
          opacity: 0.7,
          fontSize: 16,
          lineHeight: 1,
          padding: '0 2px',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.opacity = '1'; }}
        onMouseLeave={(e) => { e.currentTarget.style.opacity = '0.7'; }}
      >
        ×
      </button>
    </div>
  );
};

export const ToastContainer = ({ toasts, onRemove }) => (
  <>
    <style>{KEYFRAMES}</style>
    <div
      aria-label="Notificações"
      style={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      {toasts.map(toast => (
        <div key={toast.id} style={{ pointerEvents: 'auto' }}>
          <Toast {...toast} onRemove={onRemove} />
        </div>
      ))}
    </div>
  </>
);
